module.exports = __webpack_public_path__ + "static/media/salesforce.6ad05415.png";